<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter06">
<a id="page6">
</a><div class="chapterHead"><a id="page6">
</a><h2 class="chapterTitle"><a id="page6"><span class="xrefInternal"></span></a><a href="#/004TOC#chapter_06"><span class="bold">BAD TIMING</span></a></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">Maybe my doctor’s news</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">wouldn’t have caused</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">such awful blues</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">if Samantha</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">hadn’t just begun</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">applying to colleges—</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">none of which</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">are within a thousand-mile radius</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">of home.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">Maybe his words would have hurt less to hear</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">if thoughts of my looming empty nest</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">hadn’t caused such a splitting in my chest</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">that in the last few weeks,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">on more than one occasion,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I’d nearly dialed 911.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">If my doctor</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">had picked a better day,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">if he’d broken the news in a gentler way,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">maybe I wouldn’t be wandering</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">around the house right now</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">with my throat so tight I can barely breathe,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">trying not to panic about next fall,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">when Michael and I will be living alone</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">for the first time in seventeen years,</p>
</div>
<div class="extract">
<a id="page7">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">roaming through these rooms,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">drifting through these tombs—</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">two lost strangers</p>
</a></div><a id="page7">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">trying to fill</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">all this space</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">by ourselves…</p>
</div>
</a></div><a id="page7">
</a></div>
<a id="page7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010-chapter06.vue?eea19696